






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {CargaTemp} from '@/model/resource/CargaTemp'
import {InputCargaTempSchema} from '@/schema/resource/CargaTemp/InputCargaTempSchema'

@Component
export default class PersistCargaTempView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputCargaTempSchema()
  cargaTemp = new CargaTemp()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.cargaTemp.getCargaTemp(id)
    }

    $.await.done('getCargaTemp')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.cargaTemp.persistCargaTemp()
    await Helper.successAndPush('system.success.persist', '/carga-temp/list')
  }
}
